module.exports = __webpack_public_path__ + "static/img/16.76151e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/16.png
// module id = 7Sx2
// module chunks = 0